import { useState, useEffect } from 'react';
import { STORE } from '@/lib/store';

const TSPM_URL = 'https://tspm-api.abrandfantastic.workers.dev/api/site-content';

// Fetches site content from TSPM and resolves store-specific keys.
// For each key in defaults, we look for `${STORE}_${key}` first (store override),
// then fall back to the bare key (RAD default / shared content).
// RAD uses bare keys as-is — no breaking change.
export function useSiteContent(defaults) {
  const [content, setContent] = useState(defaults);

  useEffect(() => {
    fetch(TSPM_URL, { signal: AbortSignal.timeout(4000) })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data) return;
        const resolved = { ...defaults };
        for (const key of Object.keys(defaults)) {
          const storeSpecific = STORE !== 'rad' ? data[`${STORE}_${key}`] : undefined;
          const bare = data[key];
          const value = (storeSpecific !== undefined && storeSpecific !== '') ? storeSpecific
                      : (bare !== undefined && bare !== '') ? bare
                      : defaults[key];
          resolved[key] = value;
        }
        setContent(resolved);
      })
      .catch(() => {});
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return content;
}
